<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-12">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row justify-content-center">
              <div class="col-lg-10 col-md-10 col-sm-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Хувийн мэдээлэл оруулах</h1>
                    <p
                      class="text-danger"
                    >Та энд хувийн мэдээллээ оруулах боломжтой болно.</p>
                  </div>

                  <div >

                    <form class="user">
                      <div>
                        <div class="form-group">
                          <label >Овог</label>
                          <input
                            v-model.trim="loginForm.lastname"
                            type="text"
                            class="form-control"
                            placeholder="Та овгоо оруулна уу"
                          />
                        </div>
                        <div class="form-group" >
                          <label >Нэр</label>
                          <input
                            v-model.trim="loginForm.name"
                            type="text"
                            class="form-control"
                            placeholder="Та нэрээ оруулна уу"
                          />
                        </div>
                        <div class="form-group" >
                          <label >Утас</label>
                          <input
                            v-model.trim="loginForm.phone"
                            type="text"
                            class="form-control"
                            placeholder="Утасны дугаараа оруулна уу"
                          />
                        </div>
                        <div class="form-group" >
                          <label >Хаяг</label>
                          <input
                            v-model.trim="loginForm.address"
                            type="text"
                            class="form-control"
                            placeholder="Та оршин суугаа хаягаа оруулна уу"
                          />
                        </div>
                        <div class="row" v-if="userProfile!=null && (userProfile.role=='student' || userProfile.role=='teacher')">
                          <div class="col">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1">Сургууль:</label>
                              <select class="form-control" v-model="school" @change="department=null;program=null">
                                <option v-for="(school, index) in schools" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.name}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col" v-if="school!=null">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1">Тэнхим:</label>
                              <select class="form-control" v-model="department"  @change="program=null">
                                <option v-for="(dep, index) in school.departments" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.name}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="form-group" v-if="department!=null && userProfile!=null && (userProfile.role=='student')">
                          <label for="exampleFormControlSelect1">Хөтөлбөр:</label>
                          <select class="form-control" v-model="program" >
                            <option v-for="(pro, index) in department.programs" v-bind:key="pro.id" v-bind:value="pro">{{index+1}}.  {{pro.name}}</option>
                          </select>
                        </div>
                      </div>

                      <div @click="saveProfile" class="btn btn-primary btn-block">
                        <span>Хадгалах</span>
                      </div>
                      <hr />
                    </form>
                  </div>



                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../../firebaseConfig.js");

export default {
  name: "UserProfile",
  data() {
    return {
      loginForm: {
        name: null,
        lastname: null,
        address:null,
        phone:null
      },
      schools:[],
      school:null,
      department:null,
      program:null

    };
  },
  computed: {
    ...mapState(["currentUser", "enabled", "userProfile"])
  },
  async created() {
    var _this = this;
    if (this.currentUser != null) {

      if(this.userProfile.customer!=null){
        var data=await this.userProfile.customer.get();
        this.loginForm=data.data();
      }
      this.getSchools();
    }
  },
  methods: {
    async saveProfile(){
      if (this.currentUser != null) {
        if(this.userProfile.customer!=null){
          // if(this.school!=null && this.school!=undefined && this.school.id!=null){
          //   this.loginForm.school=fb.db.collection("schools").doc(this.school.id);
          //   if(this.department!=null && this.department!=undefined && this.department.id!=null){
          //     this.loginForm.department=fb.db.collection("schools").doc(this.school.id).collection("departments").doc(this.department.id);
          //     if(this.userProfile!=null && this.userProfile.role=="teacher")
          //       this.loginForm.schoolSelected=true;
          //     else if(this.userProfile!=null && this.userProfile.role=="student"){
          //       if(this.program!=null && this.program!=undefined && this.program.id!=null){
          //         this.loginForm.program=fb.db.doc("schools/"+this.school.id+"/departments/"+this.department.id+"/programs/"+this.program.id);
          //         this.loginForm.schoolSelected=true;
          //       }
          //     }
          //   }
            
          // }

          await this.userProfile.customer.update(this.loginForm);
          this.$router.back();
        }
      }
    },
    async getSchools(){
      var schoolsData=await fb.db.collection("schools").get()
      if(!schoolsData.empty){
        for (const schoolSnp of schoolsData.docs) {
          let object=schoolSnp.data();
          object.id=schoolSnp.id;
          object.departments=[];
          this.getDepartments(object, schoolSnp.ref);
          this.schools.push(object);

          if(this.loginForm.school!=null && this.loginForm.school!=undefined && this.loginForm.school.id!=null && this.loginForm.school.id==object.id)
            this.school=object;
          
        }
      }
     
    },
    async getDepartments(school, schoolRef){
      var departmentData=await fb.db.collection("schools/"+school.id+"/departments").get()
      if(!departmentData.empty){
        for (const depSnp of departmentData.docs) {
          let object=depSnp.data();
          object.id=depSnp.id;
          object.programs=[];
          this.getPrograms(school, object, depSnp.ref);
          school.departments.push(object);
          if(this.loginForm.department!=null && this.loginForm.department!=undefined && this.loginForm.department.id!=null && this.loginForm.department.id==object.id)
          { 
            this.department=object;
          }
        }
      }
     
    },
    async getPrograms(school, department, departmentRef){
      var programsData=await fb.db.collection("schools/"+school.id+"/departments/"+department.id+"/programs").get()
      if(!programsData.empty){
        for (const programSnp of programsData.docs) {
          let object=programSnp.data();
          object.id=programSnp.id;
          department.programs.push(object);
          if(this.loginForm.program!=null && this.loginForm.program!=undefined && this.loginForm.program.id!=null && this.loginForm.program.id==object.id)
            this.program=object;
        }
      }
     
    }

   
  }
};
</script>

